export default function RegularList({ items, ItemComponent, props = {} }) {
    return (
        <>
            {items.map((item, i) => (
                <ItemComponent key={i} {...item} {...props} />
            ))}
        </>
    );
}
